@if (didParametersLoad && dynamicFormFields.length > 0) {
    <ng-container [formGroup]="formGroup">
        <h2 class="form-subtitle">{{ 'Alerts.Parameters' | translate }}</h2>
        <div>
            @for (formField of dynamicFormFields; track formField.key) {
                <sl-dynamic-form-field [formField]="formField" [control]="formGroup.controls[formField.key] | formControl" />
            }
        </div>
    </ng-container>
}
